import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "../domain/user-service";
import { ChannelPermissonNames, RoleNames } from "../domain/user";
import {
  BatchUploadGuard,
  ChannelCreatorGuard,
  MAMEditorGuard,
  RecordingManagerGuard,
  SuperUserGuard,
  UsersManagerGuard,
} from "./permission.guard";

@Injectable()
export class ChannelActivateDeactivateGuard {
  constructor(
    private userService: UserService,
    private router: Router,
  ) {}

  canActivate() {
    return this.userService.getCurrentChannel().then((currentChannel) => {
      const currentUser = this.userService.getCurrentUser();
      if (currentChannel && currentUser) {
        if (
          currentUser.isSuperUser ||
          currentUser.hasActivateDeactivateChannelPermission(currentChannel)
        ) {
          return true;
        }
      }

      this.router.navigate(["channels/"]);
      return false;
    });
  }
}

@Injectable()
export class ChannelViewGuard {
  constructor(
    private userService: UserService,
    private router: Router,
  ) {}

  canActivate() {
    return this.userService.getCurrentChannel().then((currentChannel) => {
      const currentUser = this.userService.getCurrentUser();
      if (currentChannel && currentUser) {
        if (
          currentUser.isSuperUser ||
          currentUser.hasViewSchedulerPermission(currentChannel)
        ) {
          return true;
        }
      }

      this.router.navigate(["channels/"]);
      return false;
    });
  }
}

@Injectable()
export class ChannelEditSettingsGuard {
  constructor(
    private userService: UserService,
    private router: Router,
  ) {}

  canActivate() {
    return this.userService.getCurrentChannel().then((currentChannel) => {
      const currentUser = this.userService.getCurrentUser();
      if (currentChannel && currentUser) {
        if (
          currentUser.isSuperUser ||
          currentUser.hasEditChannelSettingsPermission(currentChannel)
        ) {
          return true;
        }
      }

      this.router.navigate(["channels/"]);
      return false;
    });
  }
}

@Injectable()
export class ChannelEditScheduleGuard {
  constructor(
    private userService: UserService,
    private router: Router,
  ) {}

  canActivate() {
    return this.userService.getCurrentChannel().then((currentChannel) => {
      const currentUser = this.userService.getCurrentUser();
      if (currentChannel && currentUser) {
        if (
          currentUser.isSuperUser ||
          currentUser.hasEditSchedulePermission(currentChannel)
        ) {
          return true;
        }
      }

      this.router.navigate(["channels/"]);
      return false;
    });
  }
}
